import { Alert, Box, Button, Chip, Snackbar } from "@mui/material";
import { usePremiseWorkspace } from "../context/PremiseWorkspace";

/**
 * Save for the premise in scope, in the app header.
 *
 * The premise editor used to own this button. Now that its sections are spread
 * across product areas, the draft is shared and so is the one control that
 * commits it - otherwise each area would need its own, and you could leave one
 * with unsaved edits by clicking into another.
 */
export default function WorkspaceSaveBar() {
  const { dirty, saving, save, lastResult, clearResult } =
    usePremiseWorkspace();

  return (
    <>
      {dirty && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            flexShrink: 0,
          }}
        >
          <Chip
            size="small"
            color="warning"
            variant="outlined"
            label="Unsaved changes"
            data-testid="dirty-indicator"
          />
          <Button
            variant="contained"
            color="secondary"
            size="small"
            disabled={saving}
            onClick={save}
            data-testid="save"
          >
            {saving ? "Saving…" : "Save"}
          </Button>
        </Box>
      )}
      <Snackbar
        open={!!lastResult}
        autoHideDuration={3000}
        onClose={clearResult}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        {lastResult ? (
          <Alert severity={lastResult.severity}>{lastResult.msg}</Alert>
        ) : undefined}
      </Snackbar>
    </>
  );
}
